module.exports = __webpack_public_path__ + "img/重庆武隆芙蓉湖国家湿地公园@2x.9d0b333a.png";